import ApiUtils from "../ApiUtils";

export default class ApiLibraryService {

    async GetDirectories(link) {
        const url = link ? `library/view?link=${link}` : "library/view";
        return await ApiUtils.callApi(url,'get');
    }

    async DeleteDirectory(link,file_name) {
        const url = file_name ? `library/delete/file-folder?link=${link}&file_name=${file_name}` : `library/delete/file-folder?link=${link}`;
        return await ApiUtils.callApi(url,'delete');
    }

    async AddDirectory(formData){
        return await ApiUtils.callApi('library/add/folder','post',formData);
    }

    async uploadFile(formData){
        return await ApiUtils.callApi('library/add/file','post',formData);
    }
}
